// extracted by mini-css-extract-plugin
module.exports = {"submenu__feature":"SubMenuFeature_submenu__feature__WN2y9","feature-link":"SubMenuFeature_feature-link__iX9eJ","feature-wrapper":"SubMenuFeature_feature-wrapper__BYD_N"};